export function decodeHtml(str = '') {
  return str
    .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(dec))
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
}
// ponytail: EN is the default locale and is served from the site root, so it
// carries no path prefix. Only sc/tc are prefixed.
const PREFIXED_LOCALES = ['sc', 'tc']

export function localePrefix(locale) {
  return PREFIXED_LOCALES.includes(locale) ? `/${locale}` : ''
}

export function localeFromPath(path = '') {
  const seg = path.split('/')[1]
  return PREFIXED_LOCALES.includes(seg) ? seg : 'en'
}

/** Same page, different locale. */
export function localePath(locale, path = '/') {
  return `${localePrefix(locale)}${path.replace(/^\/(sc|tc)(?=\/|$)/, '')}` || '/'
}

// The CMS composes doogroup links as `{client_host}/{lang}{path}` (getMenuList
// in v2-cms-system), so it always emits the retired /en/ prefix — on whatever
// host we asked for. Fixing it there would touch every other entity's footer,
// so strip it here instead; the footer would otherwise link through an nginx
// 301. Same-host only, so blog.doo.com and the product sites keep their /en/.
export function dropEnPrefix(payload, origin = '') {
  const host = origin.replace(/^https?:\/\//, '')
  return JSON.parse(JSON.stringify(payload).replaceAll(`//${host}/en/`, `//${host}/`))
}
